import { createGlobalStyle } from 'styled-components';
import { colorVarNames, fontVarNames } from 'voyager';

export const VoyagerThemeBridge = createGlobalStyle`
  :root {
    ${colorVarNames.primary}: ${({ theme }) => theme.customColors.primary};
    ${fontVarNames.heading}: ${({ theme }) => theme.headerFont}, serif;
    ${fontVarNames.body}: ${({ theme }) => theme.bodyFont}, sans-serif;
  }
`;
